import type { User } from "@shuttlerock/auth-types";
import { allowAllFeatureGate } from "./defaultGate";
import type { FeatureGate } from "./types";

/**
 * Capability gating is constitutively allow-all: every caller receives the same
 * constant gate regardless of user. The signature exists only for callsite
 * compatibility until the remaining route-stub callers are deleted.
 */
export const registerFeatureGateForUser = (_user?: User): FeatureGate => allowAllFeatureGate;
